// Do not edit manually

export const IMAGES = {
  LOGO_BARNA: "/images/logo_barna.png",
  // Original PDF images
  COVER_BG: "/images/cropped_image_3_1774461960498056058.jpg",
  COMMUNITY_BG: "/images/cropped_image_6_1774461961054328515.jpg",
  NEIGHBORHOOD_BG: "/images/cropped_image_2_1774461960558613686.jpg",
  MERCAT_CLOT: "/images/mercat_clot.jpg",
  STREET_BG: "/images/cropped_image_8_1774461961144715031.jpg",
  // Player photos — new uploads
  GB_147: "/images/GB_147.jpg",
  GB_146: "/images/GB_146.jpg",
  GB_003: "/images/GB_003.jpg",
  GB_009: "/images/GB_009.jpg",
  GB_143: "/images/GB_143.jpg",
  GB_144: "/images/GB_144.jpg",
  GB_145: "/images/GB_145.jpg",
  GB_MATCH_WOMEN: "/images/GB_match_women.jpg",
  GB_MATCH_MEN: "/images/GB_match_men.jpg",
  // Architecture / neighborhood
  TORRE_GLORIES: "/images/torre_glories.jpg",
  BCN_ARQUITECTURA: "/images/barcelona_arquitectura.png",
  // Entrenadores/es
  ENT_42: "/images/ENT_42.jpg",   // 2 entrenadoras (solo chicas)
  ENT_36: "/images/ENT_36.jpg",   // 2 jugadoras + entrenador
  ENT_65: "/images/ENT_65.jpg",   // 2 chicas + chico
  ENT_47: "/images/ENT_47.jpg",   // entrenadora + entrenador
  ENT_56: "/images/ENT_56.jpg",   // 2 chicos + chica
  ENT_62: "/images/ENT_62.jpg",   // chica + 2 chicos
  ENT_34: "/images/ENT_34.jpg",   // 4 entrenadores grupo
  // Els Màgics
  MAGICS_005: "/images/MAGICS_005.jpg", // jugador Màgics #9 amb pilota
  // Logos partners
  LOGO_EIX_CLOT: "/images/logo_eix_clot_new.png",
  LOGO_FEDE_CLOT: "/images/logo_fede_clot.jpg",
  LOGO_SANT_MARTI: "/images/logo_ajunt_sant_marti_new.png",
  LOGO_EIX_SANT_MARTI: "/images/logo_eix_sant_marti_new.png",
  // Premi Dona i Esport
  PREMI_DONA_1: "/images/premi_dona_1.jpg",
  PREMI_DONA_2: "/images/premi_dona_2.jpg",
  PREMI_ESCUDE_1: "/images/premi_escude_1.jpg",
  // Esport Segur
  LOGO_ESPORT_SEGUR: "/images/logo_esport_segur.jpg",
  // Protecció del menor
  LOGO_PROTECCIO: "/images/logo_proteccio_inf.jpg",
  // Instagram institucional
  INST_CONSELLER_1: "/images/inst_conseller_1.jpg",
  INST_ALCALDE_1: "/images/inst_alcalde_1.jpg",
  INST_DAVID_1: "/images/inst_david_1.jpg",
  ESCUDE_GROUP: "/images/escude_group.jpg",
  // Sponsors / Col·laboradors
  SP_STEPBACK: "/images/sp_stepback.jpg",
  SP_ZAPIC: "/images/sp_zapic.png",
  SP_AQUARIUM: "/images/sp_aquarium.png",
  SP_OVELLA: "/images/sp_ovella.png",
  SP_MANUALCOLOR: "/images/sp_manualcolor.png",
  SP_MELOSA: "/images/sp_melosa.png",
  SP_TIMECHAMBER: "/images/sp_timechamber.png",
  SP_FUJIFILM: "/images/sp_fujifilm.png",
  // Partners full image
  PARTNERS_TOP: "/images/partners_top.jpg",
  PARTNERS_BOTTOM: "/images/partners_bottom.jpg",
  PARTNERS_FULL: "/images/partners_full.jpg",
  // New individual sponsor logos
  MERCAT_CLOT_NEW: "/images/mercat_clot_new.jpg",
  SP_WESTFIELD: "/images/sp_westfield.png",
  SP_ENCANTS: "/images/sp_encants.png",
  SP_GLOBASKET: "/images/sp_globasket.png",
  SP_TOTSALUT: "/images/sp_totsalut.png",
  SP_MULLOR: "/images/sp_mullor.png",
  SP_HERBOLARI: "/images/sp_herbolari.png",
  SP_ARMAND: "/images/sp_armand.jpg",
  SP_AGUAMIGA: "/images/sp_aguamiga.webp",
  SP_BAC_DE_RODA: "/images/sp_bac_de_roda.png",
  SP_WILSON: "/images/sp_wilson.png",
  SP_ROMEO: "/images/sp_romeo.png",
  SP_ESPORTCAT: "/images/sp_esportcat.png",
  SP_EIX_CLOT: "/images/sp_eix_clot.png",
  SP_SANT_MARTI: "/images/sp_sant_marti.png",
  SP_ILLA_FANTASIA: "/images/sp_illa_fantasia.png",
  SP_GBK: "/images/sp_gbk.png",
  SP_FOTOJANE: "/images/sp_fotojane.png",
} as const;

export type ImageKey = keyof typeof IMAGES;
